import { ChevronLeft } from 'lucide-react'

import { cn } from '../lib/utils'
import { Button } from './ui/button'

export const BackButton = () => {
  const handleBack = () => {
    // Check if there's actual history to go back to
    if (window.history.length > 1) {
      // Use browser back if history exists
      window.history.back()
    } else {
      // Fallback: navigate to the homepage (root of current origin)
      const homepageUrl = `${window.location.origin}/`

      // Only navigate if we're not already on the homepage
      if (window.location.href !== homepageUrl) {
        window.location.href = homepageUrl
      }
    }
  }

  return (
    <Button
      onClick={handleBack}
      size='icon'
      variant='secondary'
      aria-label='Gå tilbage'
      className={cn(
        'fixed z-20 rounded-full bg-white shadow-lg hover:bg-gray-50 dark:bg-slate-900',
        // Mobile: top-left, smaller size
        'left-2 top-4 h-10 w-10',
        // Tablet (lg breakpoint = 1024px): bottom-left, larger size
        'lg:bottom-5 lg:left-6 lg:top-auto lg:h-14 lg:w-14',
        // Desktop (xl breakpoint = 1280px, ~1200px): back to top-left
        'xl:bottom-auto xl:top-6 xl:h-16 xl:w-16',
      )}
    >
      <ChevronLeft className='h-5 w-5 lg:h-6 lg:w-6' />
    </Button>
  )
}
